/**
 * Template: Blog
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Blog template.
 *
 * @namespace blog
 */

const content = document.querySelector(".main-content");
const bgElement = document.querySelector(".c-blog-background");
const gridItems = document.getElementsByClassName("c-blog");
const filterTriggers = document.getElementsByClassName("js-filter");
const filtersMobile = document.querySelector(".js-filter-mobile");
const ajaxTrigger = document.querySelector("#ajax-trigger");
const blogGridLinks = document.querySelectorAll(".js-blog-link");

function toggleFilterClicks() {
  if (!filtersMobile)  { return }

  filtersMobile.addEventListener('click', function(){
    if (filtersMobile.classList.contains("js-active")) {
      filtersMobile.classList.remove("js-active");
    } else {
      filtersMobile.classList.add("js-active");
    }
  })


  blogGridLinks.forEach((item) => {
    item.addEventListener('click', function(event){
      event.preventDefault();
      const link = item.dataset.link;
      window.location.assign(link);
    })
  });
}

function clearLazyload(img) {
  if (img.classList.contains("lazyloaded")) {
    img.src = "";
    img.classList.remove("lazyloaded");
    img.classList.add("lazyload");
  }
}

function showHideStories(filterVal) {
  for (let i = 0; i < gridItems.length; i += 1) {
    // Reset everything to display
    gridItems[i].classList.add("js-active");

    if (gridItems[i].classList.contains("c-blog--hide")) {
      gridItems[i].classList.remove("c-blog--hide");
    }

    // Set classes to hide and set grid style
    if (!gridItems[i].classList.contains(filterVal)) {
      gridItems[i].classList.add("c-blog--hide");

      if (gridItems[i].classList.contains("js-active")) {
        gridItems[i].classList.remove("js-active");
      }
    }
  }
}

function doGridLayout() {
  const layoutItems = document.getElementsByClassName("js-active");
  const layout = ["huge", "large", "tall", "tall", "large", "large", "tall"];
  let layoutCount = 0;

  for (let i = 0; i < layoutItems.length; i += 1) {
    layoutItems[i].dataset.size = layout[layoutCount];
    layoutCount += 1;

    // Reset the loop count
    if (layoutCount == layout.length) {
      layoutCount = 0;
    }

    // Get the image
    const image = layoutItems[i].querySelector(".js-image");

    // Set 'tall' to portrait image src - reset the others
    if (image) {
      if (
        layoutItems[i].dataset.size == "tall" &&
        image.dataset.src != image.dataset.tall
      ) {
        clearLazyload(image);
        if(image.dataset.tallratio) {
          image.parentElement.style.paddingTop = image.dataset.tallratio*100+'%';
        }
        image.dataset.src = image.dataset.tall;
      } else if (
        (layoutItems[i].dataset.size == "huge" &&
          image.dataset.src != image.dataset.standard) ||
        (layoutItems[i].dataset.size == "large" &&
          image.dataset.src != image.dataset.standard)
      ) {
        clearLazyload(image);
        if(image.dataset.standardratio) {
          image.parentElement.style.paddingTop = image.dataset.standardratio*100+'%';
        }
        image.dataset.src = image.dataset.standard;
      }
    }
  }

  // On page, laid out, ready to filter
  filterReadyState = 1;
}

document.addEventListener("DOMContentLoaded", function () {
  toggleFilterClicks();
});

window.addEventListener("load", doGridLayout);
